import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import dayjs from "dayjs";

const SalesByLeadReport: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);

  const columns: GridColDef[] = [
   { field: "invoiceCount", headerName: "Invoice Count", flex: 1 },
    { field: "totalSale", headerName: "Total Sale", flex: 1 },
    { field: "totalTax", headerName: "Total Tax", flex: 1 },
    { field: "totalSaleWithTax", headerName: "Sale With Tax", flex: 1 },
  ];

 const handleApply = async (payload: any) => {
     try {
       const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
       const toDate = dayjs(payload.to).format("YYYY-MM-DD");
   
       const userId = localStorage.getItem(LoacalVariables.UserId);
       if (!userId) {
         alert("UserId not found. Please login again.");
         return;
       }
   
       console.log("Using userId:", userId);
   
       const query = `?fromdate=${fromDate}&to=${toDate}&userId=${userId}`;
   
       const response = await callAPI(
         `FinancialReport/Invoice-report${query}`,
         Method.GET
       );
   
       console.log("API Response:", response);
   
       // Map rows with unique id for DataGrid
       setRows(
         (response?.data?.report || []).map((row: any, index: number) => ({
           ...row,
           id: index,
         }))
       );
     } catch (err) {
       console.log("Error fetching Sales Report", err);
     }
   };
 

  return (
    <ReportBaseTemplate
      title="Sales By Lead Report"
      columns={columns}
      rows={rows}
      onApply={handleApply}
    />
  );
};

export default SalesByLeadReport;
